  import { strapi } from '@strapi/client';
  import strapiConfig from '../config/cms';
  
  
  const client = strapi({
      baseURL: strapiConfig.baseURL,
      auth: strapiConfig.auth,
    });


 export default client;